

import React, { useState } from "react";
import MonthYearSelector from "./MonthYearSelector";
import ReportTable from "./ReportTable";
import {
  getDistrictWiseReport,
  getBlockWiseReport,
  getFpsWiseReport,
  downloadDistrictWiseExcel,
  downloadBlockWiseExcel,
  downloadFpsWiseExcel,
} from "../../Service/api";

const getMonthName = (monthNumber) => {
  const date = new Date();
  date.setMonth(parseInt(monthNumber, 10) - 1);
  return date.toLocaleString("en-IN", { month: "long" });
};

function ChangeStatment_F_rpt() {
  const [reportData, setReportData] = useState(null);
  const [blockReportData, setBlockReportData] = useState(null);
  const [fpsReportData, setFpsReportData] = useState(null);

  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedBlock, setSelectedBlock] = useState(null);
  const [currentMonth, setCurrentMonth] = useState("");
  const [currentYear, setCurrentYear] = useState("");

  const [currentMonthName, setCurrentMonthName] = useState("");
  const [currentBlockName, setCurrentBlockName] = useState("");

  const [loading, setLoading] = useState(false);
  const [blockLoading, setBlockLoading] = useState(false);
  const [fpsLoading, setFpsLoading] = useState(false);

  const [error, setError] = useState(null);
  const [blockError, setBlockError] = useState(null);
  const [fpsError, setFpsError] = useState(null);

  const fetchReport = async (month, year) => {
    setLoading(true);
    setError(null);
    setReportData(null);
    setBlockReportData(null);
    setFpsReportData(null);
    setSelectedDistrict(null);
    setSelectedBlock(null);
    setCurrentMonth(month);
    setCurrentYear(year);

    setCurrentMonth(month);
    setCurrentYear(year);
    setCurrentMonthName(getMonthName(month));
    setCurrentBlockName("");

    try {
      const data = await getDistrictWiseReport(month, year);
      setReportData(data);
    } catch (err) {
      setError("Failed to fetch district wise report.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchBlockReport = async (distCode, districtName) => {
    setBlockLoading(true);
    setBlockError(null);
    setBlockReportData(null);
    setFpsReportData(null);
    setSelectedDistrict(distCode);
    setSelectedBlock(null);

    setCurrentBlockName(districtName);

    try {
      const data = await getBlockWiseReport(
        distCode,
        currentMonth,
        currentYear
      );
      setBlockReportData(data);
    } catch (err) {
      setBlockError("Failed to fetch block wise report.");
      console.error(err);
    } finally {
      setBlockLoading(false);
    }
  };

  const fetchFpsReport = async (distCode, officeCode, blockName) => {
    setFpsLoading(true);
    setFpsError(null);
    setFpsReportData(null);
    setSelectedBlock(officeCode);

    setCurrentBlockName(blockName);

    try {
      const data = await getFpsWiseReport(
        distCode,
        officeCode,
        currentMonth,
        currentYear
      );
      setFpsReportData(data);
    } catch (err) {
      setFpsError("Failed to fetch FPS wise report.");
      console.error(err);
    } finally {
      setFpsLoading(false);
    }
  };

  const handleDownloadDistrictReport = async () => {
    try {
      await downloadDistrictWiseExcel(currentMonth, currentYear);
    } catch (err) {
      console.error("Failed to download district wise Excel report.", err);
    }
  };

  const handleDownloadBlockReport = async () => {
    if (selectedDistrict) {
      try {
        await downloadBlockWiseExcel(
          selectedDistrict,
          currentMonth,
          currentYear
        );
      } catch (err) {
        console.error("Failed to download block wise Excel report.", err);
      }
    }
  };

  const handleDownloadFpsReport = async () => {
    if (selectedDistrict && selectedBlock) {
      try {
        await downloadFpsWiseExcel(
          selectedDistrict,
          selectedBlock,
          currentMonth,
          currentYear
        );
      } catch (err) {
        console.error("Failed to download FPS wise Excel report.", err);
      }
    }
  };

  // const handleDownloadFullReport = async () => {
  //   try {
  //     await downloadFullDetailedStateExcel(currentMonth, currentYear);
  //   } catch (err) {
  //     console.error("Failed to download full detailed state Excel report.", err);
  //   }
  // };

  return (
    <div className="py-6">
      <div className="">
        <MonthYearSelector onSubmit={fetchReport} />
      </div>

      {loading && (
        <p className="text-center mt-6 text-blue-600 text-lg font-medium">
          Loading district report...
        </p>
      )}

      {error && (
        <p className="text-center mt-6 text-red-600 text-lg font-medium">
          Error: {error}
        </p>
      )}

      {reportData && !loading && !error && (
        <div className="py-6">
          {/* <h2 className="text-xl font-semibold mb-4 text-gray-700">
            District Wise Report
          </h2> */}
          <ReportTable
            data={reportData}
            onDistrictClick={fetchBlockReport}
            onDownloadReport={handleDownloadDistrictReport}
            monthName={currentMonthName}
            year={currentYear}
            blockName={""}
          />
          <div
            style={{
              marginTop: "15px",
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            {/* onDownloadReport button is displayed by ReportTable component itself */}

            {/* New Full Download Button */}
            {/* <button onClick={handleDownloadFullReport} className="button button2" style={{ backgroundColor: '#28a745', color: 'white' }}>
              Download Full State Data
            </button> */}
          </div>
        </div>
      )}

      {selectedDistrict && (
        <div className="">
          {/* <h2 className="tableheader">
            Block Wise Report for District: {selectedDistrict}
          </h2> */}

          {blockLoading && (
            <p className="text-center text-blue-600 text-lg font-medium">
              Loading block report...
            </p>
          )}

          {blockError && (
            <p className="text-center text-red-600 text-lg font-medium">
              Error: {blockError}
            </p>
          )}

          {blockReportData && !blockLoading && !blockError && (
            <>
              <ReportTable
                data={blockReportData}
                onBlockClick={fetchFpsReport}
                isBlockTable={true}
                onDownloadReport={handleDownloadBlockReport}
                monthName={currentMonthName}
                year={currentYear}
                blockName={currentBlockName}
              />

              {selectedBlock && (
                <div className="py-6">
                  {/* <h2 className="text-xl font-semibold mb-4 text-gray-700">
                    FPS Wise Report for Block: {selectedBlock}
                  </h2> */}
                  {fpsLoading && (
                    <p className="text-center text-blue-600 text-lg font-medium">
                      Loading FPS report...
                    </p>
                  )}

                  {fpsError && (
                    <p className="text-center text-red-600 text-lg font-medium">
                      Error: {fpsError}
                    </p>
                  )}

                  {fpsReportData && !fpsLoading && !fpsError && (
                    <ReportTable
                      data={fpsReportData}
                      isFpsTable={true}
                      onDownloadReport={handleDownloadFpsReport}
                      monthName={currentMonthName}
                      year={currentYear}
                      blockName={currentBlockName}
                    />
                  )}
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default ChangeStatment_F_rpt;
